import { render, staticRenderFns } from "./PolymorphicReferenceShowScreen.vue?vue&type=template&id=3fb328d0&"
import script from "./PolymorphicReferenceShowScreen.vue?vue&type=script&lang=js&"
export * from "./PolymorphicReferenceShowScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports